import { useState, FormEvent } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import '../styles/LoginPage.css'

export function LoginPage() {
  const { isAuthenticated, loading } = useAuth()
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  if (loading) {
    return (
      <div className="login-page">
        <div className="login-card" style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--color-text-muted)' }}>Loading...</p>
        </div>
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError('')
    setSubmitting(true)

    try {
      const res = await fetch('/api/auth/send-magic-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      })

      const data = await res.json()

      if (!res.ok || !data.success) {
        setError(data.error || 'Failed to send magic link. Please try again.')
        return
      }

      setSent(true)
    } catch {
      setError('Network error. Please check your connection and try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">Sign in to Fingerstyle</h1>
          <p className="login-subtitle">
            Enter your email and we'll send you a magic link to sign in.
          </p>
        </div>

        {sent ? (
          <div className="login-success">
            <p className="login-success-title">Check your email</p>
            <p className="login-success-text">
              We sent a magic link to <strong>{email}</strong>. Click the link in
              the email to sign in. The link expires in 15 minutes.
            </p>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            {error && <div className="login-error">{error}</div>}

            <div>
              <label className="login-label" htmlFor="login-email">
                Email address
              </label>
              <input
                id="login-email"
                className="login-input"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              className="login-submit"
              disabled={submitting || !email.trim()}
            >
              {submitting ? 'Sending...' : 'Send Magic Link'}
            </button>
          </form>
        )}

        <div className="login-back">
          <Link to="/">Back to home</Link>
        </div>
      </div>
    </div>
  )
}
